import { render, staticRenderFns } from "./BaseTableTitle.vue?vue&type=template&id=2cd119a3&"
import script from "./BaseTableTitle.vue?vue&type=script&lang=js&"
export * from "./BaseTableTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports